import type { Timeframe } from '@shared/types/candle'

export type ChartType = 'candlestick' | 'line' | 'area' | 'baseline'

export type GridSize = 1 | 2 | 4 | 6 | 8 | 12 | 16

export interface ActiveIndicator {
  /** Unique per-instance id (generated by chartStore.addIndicator). */
  instanceId: string
  /** Indicator type id from the registry (e.g. 'sma'). Multiple instances share the same id. */
  id: string
  params: Record<string, number | string | boolean>
  /** Per-line color overrides. Key = IndicatorLineDef.key. Falls back to config default. */
  colors?: Record<string, string>
  /** When false the indicator is hidden but remains saved. Defaults to true. */
  enabled?: boolean
}

/**
 * A single attachment of a custom/Pine indicator to a chart panel.
 * Multiple panels may attach the same definition; each attachment is independent.
 */
export interface AttachedCustomIndicator {
  /** Unique per-attachment id. */
  instanceId: string
  /** References customIndicatorStore.indicators[].id */
  definitionId: string
  enabled: boolean
}

export interface ChartPanel {
  id: string
  symbol: string
  timeframe: Timeframe
  chartType: ChartType
  indicators: ActiveIndicator[]
  /** Custom/Pine indicators attached to this chart. */
  customInstances: AttachedCustomIndicator[]
}

export const DEFAULT_PANEL: Omit<ChartPanel, 'id'> = {
  symbol: 'BTC',
  timeframe: '1D',
  chartType: 'candlestick',
  indicators: [],
  customInstances: [],
}

export const GRID_LAYOUTS: Record<GridSize, { cols: number; rows: number; label: string }> = {
  1: { cols: 1, rows: 1, label: '1' },
  2: { cols: 2, rows: 1, label: '2' },
  4: { cols: 2, rows: 2, label: '4' },
  6: { cols: 3, rows: 2, label: '6' },
  8: { cols: 4, rows: 2, label: '8' },
  12: { cols: 4, rows: 3, label: '12' },
  16: { cols: 4, rows: 4, label: '16' },
}
